import { FC, useEffect, useState } from 'react'
import { Button } from 'baby-design'
import { RightArrow } from 'baby-design/icons'

import css from './BackToTopButton.styles.scss'

const BackToTopButton: FC = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [isDisplayed, setIsDisplayed] = useState(false)

  useEffect(() => {
    const handleWindowResize = () => {
      setIsMobile(window.innerWidth <= 525)
    }

    handleWindowResize()
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [window])

  useEffect(() => {
    const handleWindowScroll = () => {
      if (window.scrollY > 500) {
        setIsDisplayed(true)
      } else {
        setIsDisplayed(false)
      }
    }

    window.addEventListener('scroll', handleWindowScroll)
    return () => window.removeEventListener('scroll', handleWindowScroll)
  }, [window])

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!isDisplayed) return null

  return (
    <Button
      className={css.BackToTopButton}
      icon={{
        icon: <RightArrow className={css.BackToTopButton__icon} />,
        side: 'left',
      }}
      size={isMobile ? 'sm' : 'md'}
      variant="inverted"
      onClick={handleClick}
    >
      Back to top
    </Button>
  )
}

const BackToTopButtonWrapper: FC = () => {
  if (typeof window === 'undefined') return null
  return <BackToTopButton />
}

export default BackToTopButtonWrapper
